// src/utils/seo.ts - Updated with analytics integration
import { trackPageViewWithSEO } from "./analytics";

export interface SEOData {
  title: string;
  description: string;
  keywords: string;
  ogTitle?: string;
  ogDescription?: string;
}

export const SEO_CONFIG: Record<string, SEOData> = {
  "/": {
    title:
      "Culture Lab - Transform Corporate Spaces into Cultural Experiences | The Content Group",
    description:
      "Transform corporate spaces with culture-driven branding. Get your free Culture Lab analysis for property development, hospitality venues, and retail spaces. Proven 15-25% rent premium results.",
    keywords:
      "cultural branding, corporate space transformation, Culture Lab, property development, hospitality branding",
  },
  "/culture-lab": {
    title: "Free Culture Lab Analysis - Space Transformation Tool",
    description:
      "5-minute analysis to discover how cultural branding can transform your property. Get personalised strategy for property development, hospitality, or retail spaces.",
    keywords:
      "Culture Lab analysis, space transformation, cultural strategy, property branding, free analysis",
  },
  "/about": {
    title:
      "About The Content Group – Culture Marketing & Placemaking Experts | Formerly Yolk Studios",
    description:
      "Discover The Content Group's story—led by Daisy & Alex Hill, with 25+ years across Yolk, Yolk Studios (yolkstudios.com), and Yolklore. We transform corporate spaces through culture-driven branding, transparent strategy, and placemaking that delivers real community impact. Explore our unique approach and legacy of creative property marketing.",
    keywords:
      "The Content Group, Yolk Studios, Yolklore, yolkstudios.com, culture marketing, placemaking agency, cultural branding, property marketing, space transformation, community engagement, transparent agency, creative strategy, destination marketing, asset transformation, experiential marketing",
    ogTitle:
      "About The Content Group – From Yolk Studios (yolkstudios.com) to Culture-First Placemaking",
    ogDescription:
      "Meet Daisy & Alex Hill—creators behind Yolk, Yolk Studios (yolkstudios.com), and Yolklore—now leading The Content Group. Learn how we pioneer culture marketing and placemaking for commercial spaces, blending transparency, creativity, and proven community results.",
  },
  "/family-spaces": {
    title:
      "Family Spaces Transformation – Family Placemaking & Marketing | Honey House & Oya Labs",
    description:
      "Unlock growth with family-centric placemaking and marketing. The Content Group, Honey House, and Oya Labs create family-friendly spaces, signature clubs, and events that attract, engage, and retain modern families. Evidence-based insights, proven results, and the fastest-growing parent community in Sussex.",
    keywords:
      "family placemaking, family-centric marketing, family-friendly spaces, Honey House, oyalabs.co, family events, community engagement, parent wellbeing, family activation, family club creation, property marketing for families, family retention, family audience insights, placemaking for parents, family community growth",
    ogTitle: "Family Placemaking & Marketing – Honey House & Oya Labs",
    ogDescription:
      "Transform your property or business with family-first placemaking and marketing. Partner with Honey House and Oya Labs for research-backed family experiences, signature clubs, and proven community engagement.",
  },
  "/magdrops": {
    title:
      "MagDrops – Custom Magazine Production in 4 Weeks | Editorial Content by Yolklore",
    description:
      "MagDrops creates and delivers custom magazines for businesses in just 4-6 weeks. Cut through digital noise with real editorial content, transparent pricing, and proven results. Trusted by property professionals, retailers, and brands nationwide.",
    keywords:
      "MagDrops, custom magazine production, editorial content, magazine quick run, print marketing, branded magazine, yolklore, content marketing print, property magazine, business magazine, transparent magazine pricing, fast magazine turnaround, physical marketing, direct to customer magazine",
    ogTitle: "MagDrops – Real Magazines, Real Results | Powered by Yolklore",
    ogDescription:
      "Get your own custom magazine in 4 weeks. MagDrops delivers editorial storytelling, print expertise, and transparent pricing for brands that want to connect IRL. See how print delivers results.",
  },
};

export const updatePageSEO = (path: string) => {
  const seo = SEO_CONFIG[path] || SEO_CONFIG["/"];

  // Update title
  document.title = seo.title;

  // Track page view with analytics
  trackPageViewWithSEO(path, seo.title);

  // Update meta tags
  const updateMeta = (name: string, content: string, property?: string) => {
    const selector = property
      ? `meta[property="${name}"]`
      : `meta[name="${name}"]`;
    let meta = document.querySelector(selector) as HTMLMetaElement;

    if (!meta) {
      meta = document.createElement("meta");
      if (property) {
        meta.setAttribute("property", name);
      } else {
        meta.setAttribute("name", name);
      }
      document.head.appendChild(meta);
    }

    meta.setAttribute("content", content);
  };

  // Update meta tags
  updateMeta("description", seo.description);
  updateMeta("keywords", seo.keywords);
  updateMeta("og:title", seo.ogTitle || seo.title, "property");
  updateMeta(
    "og:description",
    seo.ogDescription || seo.description,
    "property"
  );
  updateMeta("twitter:title", seo.ogTitle || seo.title, "property");
  updateMeta(
    "twitter:description",
    seo.ogDescription || seo.description,
    "property"
  );
};
